const exists = (element) => {
  return typeof(element) != 'undefined' && element != null;
};

export {
  exists,
};